import type { IconProps } from '@src/components/icons/IconProps';

/** Same mark as santa-frontend IconSocialVk. */
export function VkIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#fff"
        d="M.5 10.56c0-4.978 0-7.467 1.546-9.014C3.593 0 6.082 0 11.06 0h.88c4.978 0 7.467 0 9.013 1.546C22.5 3.093 22.5 5.582 22.5 10.56v.88c0 4.978 0 7.467-1.547 9.013C19.407 22 16.918 22 11.94 22h-.88c-4.978 0-7.467 0-9.014-1.547C.5 18.907.5 16.418.5 11.44v-.88Z"
      />
      <path
        fill="#07F"
        d="M12.207 15.9c-5.023 0-7.888-3.453-8.007-9.2h2.516c.082 4.218 1.937 6.004 3.406 6.373V6.7h2.37v3.638c1.45-.157 2.974-1.815 3.488-3.638h2.369c-.395 2.247-2.047 3.905-3.223 4.586 1.176.553 3.058 1.999 3.774 4.614h-2.608c-.56-1.75-1.955-3.104-3.8-3.288V15.9h-.286Z"
      />
    </svg>
  );
}
